import { render, staticRenderFns } from "./Dms3Edit.vue?vue&type=template&id=06c38a50&"
import script from "./Dms3Edit.vue?vue&type=script&lang=ts&"
export * from "./Dms3Edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports